module.exports = __webpack_public_path__ + "img/60.e839a3af.jpg";